export default __webpack_public_path__ + "static/media/張瑞峰.db138b33.jpg";